import React, { useEffect, useState, useRef } from "react";
import icon1 from '../assets/images/icon1.png';
import icon2 from '../assets/images/icon2.png';
import icon3 from '../assets/images/icon3.png';
import icon4 from '../assets/images/icon4.png';
import aboutusimg from '../assets/images/about-us.png';
import oilngas from '../assets/images/oilandgas.jpg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faXmark, faBars, faHandshake, faAward, faCircleCheck, faCubes, faClipboardCheck } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import kairoslogo from '../assets/images/kairos-logo.png';
import callicon from '../assets/images/call-icon.png';
import footerroundimg from '../assets/images/roundlogo.png';
import {  Modal } from "react-bootstrap";
import { apiUrl, assetsUrl } from "../config/Config";
import axios from "axios";
import Swal from 'sweetalert2';
import AOS from "aos";
import 'aos/dist/aos.css';
import { Drawer, List, ListItem, ListItemText, Button } from '@mui/material';
import { useNavigate } from "react-router-dom";
import whatsappsvg from '../assets/images/whatsapp.svg';
import banner1 from '../assets/images/banners/1.jpeg';
// import banner2 from '../assets/images/banners/2.jpeg';
import banner3 from '../assets/images/banners/3.jpeg';
import banner4 from '../assets/images/banners/4.jpeg';
import banner5 from '../assets/images/banners/5.jpeg';
import { useLocation } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
   const faqsprevdata = [
    {isshow: false, question: "ARE YOU MANUFACTURER OR MERCHANT TRADER ?", answer: "WE ARE MERCHANT TRADER - SOURCING & ARRANGING QUALITY PRODUCTS FOR OUR ESTEEMED CUSTOMERS. OUR BUYERS CAN DEAL WITH US FOR MULTIPLE PRODUCT CATEGORY UNDER ONE ROOF."},
    {isshow: false, question: "CAN YOU ALSO ARRANGE A NEW PRODUCT CATEGORY OTHER THAN LISTED IN YOUR PROFILE?", answer: "YES WE CAN, KAIROS INTERNATIONAL IS ALWAYS INTERESTED TO ADD NEW PRODUCT CATEGORY IN OUR BASKET & LOOK FOR SAME WITH OUR GENUINE SOURCES / SUPPLIERS."},
    {isshow: false, question: "ANY MINIMUM ORDER QUANTITY (MOQ)?", answer: "AS SUCH THERE IS NO MOQ ON SOME PRODUCTS & SAME CAN BE DISCUSSED BASIS CASE TO CASE ON YOUR INQUIRY. HOWEVER CERTAIN PRODUCTS CATEGORY, WE RECOMMEND FOR A REASONABLE QUANTITY TO COVER UP LICENCE, CERTIFICATION & LOGISTIC COSTS."},
    {isshow: false, question: "CAN YOU ARRANGE EXPORTS ON BEHALF OF OUR SUPPLIER IN INDIA?", answer: "YES, WE CAN ARRANGE IF SHIPMENT VOLUME IS CONTINUES. FOR MORE INFO PLEASE CONTACT US WITH YOUR REQUIREMENTS."},
    {isshow: false, question: "CAN YOU ARRANGE 3RD COUNTRY SHIPMENTS?", answer: "YES WE CAN CHECK BASIS OUR NETWORK PARTNERS, FOR MORE INFO PLEASE CONTACT US WITH YOUR REQUIREMENTS."}
   ]
   const [showenquiremodal, setshowenquiremodal] = useState(false);
   const [fullname, setfullname] = useState("");
   const [email, setemail] = useState("");
   const [number, setnumber] = useState("");
   const [message, setmessage] = useState("");
   const [showloading, setshowloding] = useState(false);

   const [faqsdata, setfaqsdata] = useState(faqsprevdata);
   const [forceupdatestate, setforceupdatestate] = useState(false);
   const [activesection, setactivesection] = useState('Home');
   const faqsdataRef = useRef([]);
   faqsdataRef.current = faqsdata;

   const homeRef = useRef(null);
   const aboutRef = useRef(null);
   const serviceRef = useRef(null);
   const faqRef = useRef(null);
   const contactRef = useRef(null);

   const [allservices, setallservices] = useState([]);
   const [selectedservice, setselectedservice] = useState({});
   const selectedserviceRef = useRef();
   selectedserviceRef.current = selectedservice;
   const [showservicemodal, setshowservicemodal] = useState(false);

   const [open, setOpen] = useState(false);

   const location = useLocation();

   const toggleDrawer = (state) => {
    setOpen(state);
  };

   const fetallservices = async() => {
      const headers = {
        headers: {
          "Content-Type": "application/json"
        },
      };
      let resp = await axios
        .get(apiUrl + "userallservices", headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {
            if(res.data?.data?.length > 0) {
              setallservices(res.data?.data)
            } else {
              setallservices([])
            }
            
            setshowloding(false);
          } else {
            
            setshowloding(false);
          }
        })
        .catch((err) => {
          setshowloding(false);
          alert(err.message);
        });
   }

   const submithandle = async() => {
    if(fullname && email && number) {
      var data = {
        fullname: fullname,
        email: email,
        number: number,
        message: message
      }
      const headers = {
        headers: {
          "Content-Type": "application/json"
        },
      };
      let resp = await axios
        .post(apiUrl + "createenquire", data, headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {
            Swal.fire({
              title: '',
              text: "Enquired Successfully",
              icon: 'success',
              customClass: {
                icon: 'custom-swal-icon' // Apply the custom class
              },
              width: '350px',
              confirmButtonText: 'Ok',
          confirmButtonColor: "rgb(59, 151, 196)",
              customClass: {
                  popup: "small-icon-alert",
                },
            });
            setshowenquiremodal(false);
            setfullname("");
            setemail("");
            setnumber("");
            setmessage("");
            setshowloding(false);
          } else {
            
            setshowloding(false);
          }
        })
        .catch((err) => {
          setshowloding(false);
          alert(err.message);
        });
      setshowloding(false);
    } else {
      alert('Enter all required fields');
    }
   }

   const handlefaqtoggle = (index, currentstatus) => {
    var prevdata = faqsdataRef.current;
    var newdata = [];
    for(var i = 0; i < prevdata?.length; i++) {
      if(i == index) {
        var obj = prevdata[i];
        obj.isshow = !currentstatus;
        newdata.push(prevdata[i]);
      } else {
        var obj = prevdata[i];
        obj.isshow = false;
        newdata.push(prevdata[i]);
      }
    }
    setfaqsdata(newdata);
    setforceupdatestate(!forceupdatestate);
   }

   const [sticky, setSticky] = useState("");
     const isSticky = () => {
       /* Method that will fix header after a specific scrollable */
       const scrollTop = window.scrollY;
       const stickyClass = scrollTop >= 300 ? "is-sticky" : "";
       setSticky(stickyClass);
       console.log(stickyClass);
     };
     const classes = `main-header-div ${sticky} mobhide`;

     const scrollToHome = () => {
      if (homeRef.current) {
        const topOffset = homeRef.current.offsetTop; // adjust 80 for your header
        window.scrollTo({ top: topOffset, behavior: 'smooth' });
        setactivesection('Home');
        setOpen(false);
      }
    };

    const scrollToAbout = () => {
      const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
      console.log('isHeaderFixed >>', isHeaderFixed);
      const offset = isHeaderFixed ? 70 : window.innerWidth <= 1024 ? 60 : 190;

      const y = aboutRef.current.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
      setactivesection('Profile');
      setOpen(false);
    };

    const scrollToService = () => {
      const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
      console.log('isHeaderFixed >>', isHeaderFixed);
  const offset = isHeaderFixed ? 70 :  window.innerWidth <= 1024 ? 60 : 190;

  const y = serviceRef.current.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });
  setactivesection('Services');
  setOpen(false);
    };

    const scrollToFaq = () => {
      const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
      console.log('isHeaderFixed >>', isHeaderFixed);
  const offset = isHeaderFixed ? 70 : window.innerWidth <= 1024 ? 60 : 190;

  const y = faqRef.current.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });
  setactivesection('FAQs');
  setOpen(false);
    };

    const scrollToContact = () => {
      const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
      console.log('isHeaderFixed >>', isHeaderFixed);
  const offset = isHeaderFixed ? 70 : window.innerWidth <= 1024 ? 60 : 190;

  const y = contactRef.current.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });
  setactivesection('Contact');
  setOpen(false);
    };

    const handleserviceclick = (obj) => {
      console.log('obj >>', obj);
      setselectedservice(obj);
      setTimeout(() => {
        setshowservicemodal(true);
      }, 1000)
    }

    const handleshowenqmodal = () => {
      setfullname("");
            setemail("");
            setnumber("");
            setmessage("");
      setshowenquiremodal(true);
    }

    const handleclickproductbox = (item) => {
      console.log('item >>', item)
      window.open('/products/'+item?.title+'/'+item?.id, '_blank');
    }
    
   
     useEffect(() => {
       // fetchcourses();
       const handleScroll = () => {
        if(window.innerWidth <= 1024) {
          return 
        }
        const scrollY = window.scrollY + 100; // Add padding to detect a bit earlier
    
        const sections = [
          { id: "Home", ref: homeRef },
          { id: "Profile", ref: aboutRef },
          { id: "Services", ref: serviceRef },
          { id: "FAQs", ref: faqRef },
          { id: "Contact", ref: contactRef },
        ];
    
        for (let section of sections) {
          const offsetTop = section.ref.current.offsetTop;
          const offsetHeight = section.ref.current.offsetHeight;
    
          if (scrollY >= offsetTop && scrollY < offsetTop + offsetHeight) {
            setactivesection(section.id);
            break;
          }
        }

        // sticky header

        const scrollTop = window.scrollY;
       const stickyClass = scrollTop >= 300 ? "is-sticky" : "";
       setSticky(stickyClass);
       console.log(stickyClass);
      };

       window.addEventListener("scroll", handleScroll);
       return () => {
         window.removeEventListener("scroll", handleScroll);
       };

     }, []);

    //  useEffect(() => {
    //   if (location.hash) {
    //     const element = document.querySelector(location.hash);
    //     if (element) {
    //       const headerOffset = 80; // 🔥 adjust this (your navbar height)
    //       const elementPosition = element.getBoundingClientRect().top;
    //       const offsetPosition =
    //         elementPosition + window.pageYOffset - headerOffset;
    
    //       window.scrollTo({
    //         top: offsetPosition,
    //         behavior: "smooth",
    //       });
    //     }
    //   }
    // }, [location]);

    useEffect(() => {
      if (!location.hash) return;
    
      let attempts = 0;
    
      const scrollToHash = () => {
        const element = document.querySelector(location.hash);
        if (!element) return;
    
        const headerOffset = window.innerWidth <= 1024 ? 60 : 190; // navbar height
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition + window.pageYOffset - headerOffset;
    
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      };
    
      const interval = setInterval(() => {
        const element = document.querySelector(location.hash);
        if (element || attempts > 10) {
          scrollToHash();
          clearInterval(interval);
        }
        attempts++;
      }, 500);
    
      return () => clearInterval(interval);
    }, [location]);

     useEffect(() => {
      fetallservices();
      AOS.init({
        disable: window.innerWidth < 768,
     });
      AOS.refresh();
     }, [])


    return (
      <>
        <div className={classes} ref={homeRef}>
          <div className="container">
            <div className="header-row">
              <div className="header-logo-div">
                <img src={kairoslogo} className="kairoslogo" />
              </div>
              <div className="header-navbar">
                <nav className="navbar navbar-expand-lg  custom-nav ">
                  <ul class="navbar-nav">
                    <li
                      className={
                        activesection == "Home" ? "nav-item active" : "nav-item"
                      }
                    >
                      <Link onClick={scrollToHome}>Home</Link>
                    </li>
                    <li
                      className={
                        activesection == "Profile"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <Link 
                      // onClick={scrollToAbout}
                      to={"/#Profile"}
                      >Profile</Link>
                    </li>
                    <li
                      className={
                        activesection == "Services"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <Link onClick={scrollToService}>Products Range</Link>
                    </li>
                    <li
                      className={
                        activesection == "FAQs" ? "nav-item active" : "nav-item"
                      }
                    >
                      <Link onClick={scrollToFaq}>FAQs</Link>
                    </li>
                    <li
                      className={
                        activesection == "Contact"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <Link onClick={scrollToContact}>Contact</Link>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="header-number-div">
                <img src={callicon} className="calliconimg" />
                <div className="">
                  <Link to={"tel: +919819323245"} className="callicontext">
                  Mr. Sohil +91 9819323245,
                  </Link>
                  <br />
                <Link to={"tel: +919819534178"} className="callicontext">
                  Mr. Rakesh +91 9819534178
                </Link>
                </div>
                
              </div>
            </div>
          </div>
        </div>
        <div className="deskhide">
          <div className="mobilemaindiv">
            <div
              className="mobilemenudiv"
              onClick={() => {
                setOpen(true);
              }}
            >
              <FontAwesomeIcon icon={faBars} className="menubaricon" />
            </div>
            <img src={kairoslogo} alt="Logo" className="website-logo" />
          </div>
          <div className="navbarheight" />

          <Drawer
            anchor="left"
            open={open}
            onClose={() => {
              toggleDrawer(false);
            }}
          >
            <List sx={{ width: 250 }}>
              <div className="mobilemenusidebarmaindiv">
                <div
                  className="mobilemenusidebar-closediv"
                  onClick={() => {
                    toggleDrawer(false);
                  }}
                >
                  <FontAwesomeIcon
                    icon={faXmark}
                    className="menubariconsidebar"
                  />
                </div>
                <nav className="navbar navbar-expand-lg  custom-nav ">
                  <ul class="navbar-nav">
                    <li
                      className={
                        activesection == "Home" ? "nav-item active" : "nav-item"
                      }
                    >
                      <Link onClick={scrollToHome}>Home</Link>
                    </li>
                    <li
                      className={
                        activesection == "Profile"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <Link onClick={scrollToAbout}>Profile</Link>
                    </li>
                    <li
                      className={
                        activesection == "Services"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <Link onClick={scrollToService}>Products Range</Link>
                    </li>
                    <li
                      className={
                        activesection == "FAQs" ? "nav-item active" : "nav-item"
                      }
                    >
                      <Link onClick={scrollToFaq}>FAQs</Link>
                    </li>
                    <li
                      className={
                        activesection == "Contact"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <Link onClick={scrollToContact}>Contact</Link>
                    </li>
                  </ul>
                </nav>
              </div>
              {/* {['Dashboard', 'Profile', 'Settings', 'Logout'].map((text) => (
            <ListItem button key={text}>
              <ListItemText primary={text} />
            </ListItem>
          ))} */}
            </List>
          </Drawer>
        </div>
        <section>
          {/* Whatsapp Icon */}
          <Link
            to={"https://wa.me/919819323245"}
            target="_blank"
            className="whatsappicon-div"
          >
            <img src={whatsappsvg} className="whatsapp-icon" />
          </Link>

          {/* <div className="home-banner">
            <div className="container">
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="banner-leftdiv">
                    <p className="banner-text" data-aos="fade-up" data-aos-delay="0" data-aos-duration="500">
                      Driven by Trade, Defined by Trust
                    </p>
                    <p className="banner-delivery-text" data-aos="fade-up" data-aos-delay="300" data-aos-duration="500">
                      Delivering Quality Products
                      <br />
                      Around The World
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="banner-right-bg"></div>
                </div>
              </div>
            </div>
          </div> */}

          <div id="demo" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner">
              <div class="carousel-item active">
                <div className="home-banner home-banner1"></div>
              </div>
              <div class="carousel-item">
                <div className="home-banner home-banner2"></div>
              </div>
              <div class="carousel-item">
                <div className="home-banner home-banner3"></div>
              </div>
              <div class="carousel-item">
                <div className="home-banner home-banner4"></div>
              </div>
              <div class="carousel-item">
                <div className="home-banner home-banner5"></div>
              </div>
            </div>

            {/* Left and right controls/icons */}
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#demo"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon"></span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              data-bs-target="#demo"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon"></span>
            </button>
          </div>

          <div
            className="get-a-quotebtn-div"
            onClick={() => {
              handleshowenqmodal();
            }}
          >
            <p>Get A Quote</p>
          </div>
        </section>
        <section >
          <div className="section2-bg">
            <div className="container">
              <div className="section2-maindiv">
                <div
                  className="section2-boxdiv"
                  data-aos="fade-up"
                  data-aos-delay="0"
                  data-aos-duration="500"
                >
                  {/* <img src={icon1} className="box-icon1" /> */}
                  <FontAwesomeIcon icon={faHandshake} className="box-icon1" />
                  <p className="section2-boxtext">
                    Reliable Trade
                    <br />
                    Partner
                  </p>
                </div>
                <div
                  className="section2-boxdiv no-right-border"
                  data-aos="fade-up"
                  data-aos-delay="300"
                  data-aos-duration="500"
                >
                  <img src={icon3} className="box-icon1" />
                  <p className="section2-boxtext">
                    Professional
                    <br /> Team
                  </p>
                </div>
                <div
                  className="section2-boxdiv"
                  data-aos="fade-up"
                  data-aos-delay="600"
                  data-aos-duration="500"
                >
                  {/* <img src={icon2} className="box-icon1" /> */}
                  <FontAwesomeIcon icon={faAward} className="box-icon1" />
                  <p className="section2-boxtext">
                    Quality
                    <br />
                    Products
                  </p>
                </div>

                <div
                  className="section2-boxdiv no-right-border"
                  data-aos="fade-up"
                  data-aos-delay="900"
                  data-aos-duration="500"
                >
                  {/* <img src={icon4} className="box-icon1" /> */}
                  <FontAwesomeIcon
                    icon={faClipboardCheck}
                    className="box-icon1"
                  />
                  <p className="section2-boxtext">
                    Inhouse Customs
                    <br />
                    Clearance
                  </p>
                </div>

                <div
                  className="section2-boxdiv no-bottom-border"
                  data-aos="fade-up"
                  data-aos-delay="1200"
                  data-aos-duration="500"
                >
                  {/* <img src={icon4} className="box-icon1" /> */}
                  <FontAwesomeIcon icon={faCubes} className="box-icon1" />
                  <p className="section2-boxtext">
                    Multifaced Products
                    <br />
                    Offered
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section ref={aboutRef} id="Profile">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div
                  className="about-us-leftdiv"
                  data-aos="fade-right"
                  data-aos-delay="500"
                  data-aos-duration="1000"
                >
                  <p className="about-us-title">about us</p>
                  <p className="relaible-transport-text">reliable PARTNER</p>
                  <p className="relaible-transport-text relaible-transport-text1">
                    for the world
                  </p>
                  <p className="about-us-desc">
                    KAIROS INTERNATIONAL is a trusted name in global trade,
                    specializing in the import & export of diverse commodities. We strive
                    to be a reliable partner for businesses looking to grow
                    across borders.
                    <br />
                  </p>
                  <p className="about-us-desc">
                    Our Mission is to simplify international trade by delivering
                    high-quality products and exceptional service. We bridge the
                    gap between local enterprises and global markets, driving
                    economic growth and building lasting partnerships.
                  </p>
                  {/* <div className="readmore-btn-div">
                    <p>Read More</p>
                  </div> */}
                </div>
              </div>
              <div
                className="col-md-6"
                data-aos="fade-left"
                data-aos-delay="500"
                data-aos-duration="1000"
              >
                <img src={aboutusimg} className="aboutusimg" />
              </div>
            </div>
          </div>
        </section>
        <section ref={serviceRef} id="Products-range">
          <div className="service-section-bg">
            <p className="service-offered-text">Products Range</p>
            <div className="container">
              <div className="row mt-5 justify-content-center">
                {allservices?.length > 0 ? (
                  allservices?.map((item, index) => {
                    return (
                      <div className="col-12 col-sm-6 col-md-3 mb-4">
                        <div
                          className="servicebox"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handleclickproductbox(item);
                          }}
                          // data-aos="fade-up"
                          // data-aos-delay={0}
                          // data-aos-duration="1000"
                        >
                          <img
                            src={assetsUrl + "services/" + item?.image}
                            className="serviceboximgbg"
                          />
                          <div className="servicetextbg">
                            <p className="oilandgastext">{item?.title}</p>
                            <div
                              className="readmoretextdiv"
                              onClick={() => {
                                // handleserviceclick(item);
                              }}
                            >
                              <p className="readmoretext">Read More</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p className="noservice-text">Services not added.</p>
                )}
              </div>
              {allservices?.length > 0 ? (
                <div
                  className="allservices-btn"
                  onClick={() => {
                    navigate("/all-products-offered");
                  }}
                >
                  <p>All Services</p>
                </div>
              ) : null}
            </div>
          </div>
        </section>
        <section ref={faqRef} id="FAQ">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div
                  className="about-us-leftdiv"
                  data-aos="fade-right"
                  data-aos-delay="0"
                  data-aos-duration="1000"
                >
                  <p className="about-us-title">FAQS</p>
                  <p className="relaible-transport-text">
                    General{" "}
                    <span style={{ color: "rgba(10, 96, 0, 1)" }}>
                      frequently
                    </span>
                  </p>
                  <p className="relaible-transport-text relaible-transport-text1">
                    <span style={{ color: "#000" }}>asked questions</span>
                  </p>
                  <p className="about-us-desc">
                    Have questions? You’ll find clear answers to the most frequently asked queries about our offerings, work process, delivery timelines, and support. We aim to make your experience smooth and transparent from the very beginning.
                  <br />
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div
                  className="right-faqmaindiv"
                  data-aos="fade-left"
                  data-aos-delay="0"
                  data-aos-duration="1000"
                >
                  {faqsdataRef?.current?.map((item, index) => {
                    return (
                      <div className="faqbox" key={index}>
                        <div className="faqquestiondiv">
                          <p className="faq-question">{item?.question}</p>
                          <div
                            className=""
                            onClick={() => {
                              handlefaqtoggle(index, item?.isshow);
                            }}
                          >
                            {item?.isshow ? (
                              <FontAwesomeIcon
                                icon={faMinus}
                                className="faqicon"
                              />
                            ) : (
                              <FontAwesomeIcon
                                icon={faPlus}
                                className="faqicon"
                              />
                            )}
                          </div>
                        </div>
                        {item?.isshow ? (
                          <p className="faq-answer">{item?.answer}</p>
                        ) : null}
                      </div>
                    );
                  })}
                </div>
                {/* <img src={aboutusimg} className="aboutusimg" /> */}
              </div>
            </div>
          </div>
        </section>
        <section ref={contactRef} id="Contact">
          <div className="footermaindiv">
            <div className="container">
              <div className="footerflexrow">
                <div className="footerleftdiv1">
                  <img src={footerroundimg} className="footer-img" />
                  <p className="footer-address-text"><b>Our Presence</b> : INDIA & UAE</p>
                  <p className="footer-address-text footer-address-text1">
                    <span className="indiaheaderfooter">
                      <b>India :</b>
                    </span>
                    <span>
                     13th FLOOR, EMBASSY 247 PARK, LBS ROAD,
                    VIKHROLI WEST, MUMBAI - 400079. INDIA.
                    </span>
                  </p>
                  <p className="footer-address-text footer-address-text1">
                    <span>
                      <b>UAE :</b>
                    </span>
                    <span>
                    Dubai.
                    </span>
                  </p>

                </div>
                <div className="footermiddiv">
                  <div className="footerchilddiv">
                    <p className="footer-links-head">LINKS</p>
                    <ul className="links-div">
                      <li>
                        <Link onClick={scrollToHome}>Home</Link>
                      </li>
                      <li>
                        <Link onClick={scrollToAbout}>Profile</Link>
                      </li>
                      <li>
                        <Link onClick={scrollToService}>Products range</Link>
                      </li>
                      <li>
                        <Link onClick={scrollToFaq}>FAQs</Link>
                      </li>
                      <li>
                        <Link onClick={scrollToContact}>Contact</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="footerthirddiv">
                  <p className="footer-links-head">PHONE</p>
                  <p className="footer-links-text">
                    <Link to={"tel: +919819323245"} className="callicontext">
                                                      Mr. Sohil +91 9819323245,
                                                      </Link><br />
                     <Link to={"tel: +919819534178"} className="callicontext">
                                                      Mr. Rakesh +91 9819534178
                                                    </Link>
                  </p>
                  <p className="footer-links-head footer-links-email">EMAIL</p>
                  <Link to={"mailto:kairosinternational24@gmail.com"} className="footer-links-text mobhide">
                    kairosinternational24@gmail.com
                  </Link>
                  <Link to={"mailto:kairosinternational24@gmail.com"} className="footer-links-text deskhide">
                    kairosinternational24
                    <br />
                    @gmail.com
                  </Link>
                </div>
              </div>
              <p className="copyright-text">© Kairos International. All Rights Reserved. Website developed by  
                <Link to={"https://www.beakmedia.com/"} target="_blank">Beak Media.</Link>
                </p>
            </div>
          </div>
        </section>

        {/*Add modal */}
        <Modal
          show={showenquiremodal}
          onHide={() => setshowenquiremodal(false)}
          size="md"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>Get a Quote</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
              <div className="">
                <label className="addproduct-label">Full Name</label>
                <input
                  value={fullname}
                  onChange={(t) => {
                    setfullname(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Full Name"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Email</label>
                <input
                  value={email}
                  onChange={(t) => {
                    setemail(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Email"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Contact Number</label>
                <input
                  value={number}
                  onChange={(t) => {
                    setnumber(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Phone Number"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Message</label>
                <textarea
                  value={message}
                  onChange={(t) => {
                    setmessage(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Message"
                ></textarea>
              </div>

              <div className="col-md-12 mt-4">
                <div
                  className="formsubmitbtn"
                  onClick={() => {
                    submithandle();
                  }}
                >
                  <p>Submit</p>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Service Modal */}
        <Modal
          show={showservicemodal}
          onHide={() => setshowservicemodal(false)}
          size="md"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 16 }}>
              {Object.keys(selectedserviceRef?.current)?.length > 0
                ? selectedserviceRef?.current?.title
                : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
              <p className="modal-servicesubtext">
                {Object.keys(selectedserviceRef?.current)?.length > 0
                  ? selectedserviceRef?.current?.subtitle
                  : ""}
              </p>
              <div className="modal-point-maindiv">
                {Object.keys(selectedserviceRef?.current)?.length > 0
                  ? selectedserviceRef?.current?.points
                    ? selectedserviceRef?.current?.points
                        ?.split(",")
                        ?.map((item, index) => {
                          return (
                            <div className="modal-point-div" key={index}>
                              <p>{item}</p>
                            </div>
                          );
                        })
                    : null
                  : null}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
}

export default Home